import http from "../../http";

import group from "./group.js";
import tag from "./tag.js";
import field from "./field.js";

export default {

  group,  // 用户分组
  tag,    // 用户标签

  list: data => {
       return http.post("opservice/user/page/list", data); //获取用户列表
  //   return http.post("opservice/user/page", data); //获取用户列表
  },
  save: data => {
    return http.post("opservice/user/upsert", data); //保存或更新用户
  },
  batch: data => {
    return http.post("opservice/user/batch", data); //批量更新用户信息
  },
  del: data => {
    return http.post("opservice/user/delete", data); //删除用户信息
  },
  
  import: (data) => {
    return http.post("opservice/user/import", data);
  },
  importTemplate: data => {
    return http.post("opservice/user/template", data); // 导入用户模板
  },
  export: data => {
    return http.post("opservice/user/export", data); //导出用户信息
  },

  // 用户画像
  photo: {
    userinfo: data => {
      return http.get("opservice/user/portrait/" + data + "/get", {});
    },
    userinfoChange: data => {
      return http.get("opservice/user/portrait/get/info/history", data);
    },
    naire: data => {
      return http.get("opservice/user/portrait/get/form", data);
    },
    activity: data => {
      return http.get("opservice/user/portrait/get/activity", data);
    },
    form: data => {
      return http.get("opservice/user/portrait/get/applysubmit", data);
    },
    tag: data => {
      return http.get("opservice/user/portrait/get/lable", data);
    },
    sleepTags: data => {
      return http.get("opservice/user/portrait/get/lable/sleep/active", data);
    },
    customer: data => {
      return http.get("opservice/user/portrait/get/customer/info", data);
    },
    identity: data => {
      return http.get("opservice/user/portrait/get/identity/info", data);
    },
    describe: data => {
      return http.post("marketcenter/user/portrait/visit/describe", data);
    },
    detail: data => {
      return http.post("marketcenter/user/portrait/visit/detail/month", data);
    },
    crmclueid: data => {
      return http.get("opservice/user/portrait/by/crmclueid", data);
    },
    reportget: data => {
      return http.get("businessapi/company/industry/report/get", data);
    },
    reportgen: data => {
      return http.get("businessapi/company/industry/report/gen", data);
    },
    // 用户标签画像
    tagProfile: (data, params) => {
      return http.get("usertagservice/v1/tag/user/" + data + "/profile-by-id", params);
    },
    // 用户行为时间线
    timelineById: (data, params) => {
      return http.get("usertagservice/v1/tag/user/" + data + "/timeline-by-id", params);
    },
  },

  company: {
    list: data => {
      return http.get("opservice/aggres/dwcompany/page", data);
    },
    import: (data) => {
      return http.post("opservice/aggres/dwcompany/import", data);
    }
  },

  //查看手机号发送验证码
  phone: (params) => {
    return http.post("opservice/tenant/security/smscode", params);
  },
  // 查看手机号-验证完登录
  valid: (params) => {
    return http.post("opservice/tenant/security/smscode/valid", params);
  },

  field,
  userField: data => {
    return http.post("opservice/user/field", data); //获取用户字段去重值
  },
  remove: (params) => {
    return http.post("opservice/user/grouptag", params);
  }, //批量移除用户的组或标签
  newImport: (data) => {
    return http.post("opservice/user/import/with/tag/group", data);
  },
  mailTag: data => {
    return http.post("opservice/mail/tags", data);
  },
  exportList: (params) => {
    return http.post("opservice/aggres/dwcompany/netapi/export", params);
  }
};
